import React from 'react';

import PropTypes from 'prop-types';

import { URL_IMAGES_BANKS } from 'apps/promo/constants/UrlConstants';

import { AnimatedBank, BankItem, BanksList, DotsSpinner } from './styles';

class AnimatedBanks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 5,
            maxIndex: null,
            currentBatch: [0, 1, 2, 3, 4],
        };
    }

    full_time = 6000;
    timerId = null;

    componentDidMount() {
        if (!this.props.data?.length) return;
        const quantityBanks = this.props.data.length;
        const maxIndex = quantityBanks - 1;
        this.setState((state) => {
            return {
                ...state,
                maxIndex,
            };
        });
        this.timerId = setInterval(() => {
            let newCurrentBatch = [];
            let cursor = this.state.currentBatch[this.state.currentBatch.length - 1] + 1;
            for (let currentStep = 1; currentStep <= this.state.step; currentStep++, cursor++) {
                if (cursor > this.state.maxIndex) {
                    cursor = 0;
                }
                newCurrentBatch.push(cursor);
            }
            this.setState((state) => {
                return {
                    ...state,
                    currentBatch: newCurrentBatch,
                };
            });
        }, this.full_time);
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }

    arrayBanks = () => {
        const bankList = this.props.data;
        return this.state.currentBatch.map((bank, index) => {
            return (
                <BankItem key={`${bankList[bank]}${index}`}>
                    <AnimatedBank>
                        <img height="60" width="60" alt={bankList[bank]} src={`${URL_IMAGES_BANKS}/${bankList[bank]}.png`} />
                    </AnimatedBank>
                </BankItem>
            );
        });
    };

    render() {
        return (
            <BanksList>
                {this.arrayBanks()}
                <BankItem>
                    <DotsSpinner>
                        <span />
                        <span />
                        <span />
                    </DotsSpinner>
                </BankItem>
            </BanksList>
        );
    }
}

AnimatedBanks.propTypes = {
    data: PropTypes.arrayOf(PropTypes.string),
};

export default AnimatedBanks;
